import { combineReducers } from 'redux'
import { errorReducer } from './errorReducer'
import { orderInfoReducer } from './orderInfoReducer'
import { orderLineReducer } from './orderLineReducer'
import { phaseReducer } from './phaseReducer'
import { servicePackageReducer } from './servicePackageReducer'
import { servicePackageServiceReducer } from './servicePackageServiceReducer'
import { serviceQuestionMultiChoiceReducer } from './serviceQuestionMultiChoiceReducer'
import { serviceQuestionReducer } from './serviceQuestionReducer'
import { serviceReducer } from './serviceReducer'

export const rootReducer = combineReducers({servicePackageReducer, serviceReducer, phaseReducer, serviceQuestionReducer, serviceQuestionMultiChoiceReducer, servicePackageServiceReducer, orderInfoReducer, orderLineReducer, errorReducer});
